export const stringifyDate = (date) => date.toISOString().replace(/T.*$/, '');

export const localDateFromString = (dateString) => new Date(`${dateString}T00:00:00`);
